/**
 * @voltxampere/ui — Pulse Generator (Pulse) · v1.0.1 boxless
 *
 * Brand-bible v1.0.1 addendum (2026-04-25): the original rectangular
 * enclosure is dropped — the symbol now reads as a plain square wave
 * traced between two leads. The path renders 1.5 cycles centered at
 * y=13 with high=7 and low=19, leaving a clean silhouette without
 * the box outline that read as "RAM chip" at small zoom levels.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { STROKE_IVORY, STROKE_WIDTH_MAIN, VIEWBOX_DEFAULT } from "./constants.js";
export const pulseSource = {
    id: "pulse-source",
    nameTr: "Pulse",
    nameEn: "Pulse Source",
    shortcut: "⇧P",
    category: "source",
    viewBox: VIEWBOX_DEFAULT,
    terminals: [
        { x: 0, y: 13, label: "out", polarity: "out" },
        { x: 40, y: 13, label: "gnd", polarity: "in" },
    ],
    defaultLabel: "V",
    defaultValue: "0/5V",
    renderSVG: () => [
        `<line x1="0" y1="13" x2="10" y2="13" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<path d="M 10 13 L 10 7 L 18 7 L 18 19 L 26 19 L 26 7 L 30 7 L 30 13" fill="none" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}" stroke-linejoin="round"/>`,
        `<line x1="30" y1="13" x2="40" y2="13" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
    ].join(""),
};
//# sourceMappingURL=pulse-source.js.map